<!-- <ngb-carousel *ngIf="imagenes?.length>0" class="carousel slide carousel-fade">
  <ng-template ngbSlide *ngFor="let imagen of imagenes; let j=index">
   <div class="picsum-img-wrapper">
      <img [src]="imagen.imagen" style="height: 450px !important;" alt="Random first slide">
    </div>
    <div class="carousel-caption">
      <div class="container">
        <div class="row mb-3">
          <div class="col-md-1">
             <a href="javascript:history.back()" class="d-flex flex-row align-items-center text-decoration-none">
              <img src="assets/images/body/icons/volver.svg" class="pe-2" alt="">
              <h4 class="text-white mb-0"> Volver</h4>
            </a>
          </div>
        </div>
        <div class="row ">
          <div class="col-md-12">
            <h1 class="mb-1 text-white">{{tourDetail?.nombre_paquete}}</h1>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ngb-carousel> -->

<ngb-carousel  class="carousel position-absolute slide w-100 carousel-fade" [showNavigationArrows]="false" [showNavigationIndicators]="true" >
  <ng-template ngbSlide *ngFor="let imagen of imagenes; let j=index">
    <div class="carousel-inner bg-tour-detail tours-height">
      <div class=" carousel-item active" style="z-index: 0;">
        <img [src]="imagen.imagen" class="d-block " alt="..." style="height: 100% !important; width: -webkit-fill-available; object-fit: cover;">
      </div>
   </div>
  </ng-template>
</ngb-carousel>

  <section class="align-items-center d-flex tours-height" >
      <div class="position-relative tour-detail-title w-100">
          <div class="container">
              <div class="row mb-5">
                  <div class="col-lg-1">
                      <a href="javascript:history.back()" class="d-flex flex-row align-items-center text-decoration-none">
                          <img src="assets/images/body/icons/volver.svg" class="pe-2" alt="">
                          <h4 class="text-white mb-0"> Volver</h4>
                      </a>
                  </div>
              </div>
              <div class="row ">
                  <div class="col-lg-12">
                      <h1 class="mb-1 text-white">{{tourDetail?.nombre_paquete}}</h1>
                  </div>
              </div>
          </div>
      </div>
  </section>
<!--  -->


<section class="tour-detail-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-10">
        <h4 class="title-bg mt-4">Datos de Pasajeros</h4>
        <p class="mb-5">Ingresá los datos completos de cada pasajero.</p>
      </div>
      <form [formGroup]="form" class="login mb-4">
        <div formArrayName="pasajeros">
          <div [formGroupName]="i" *ngFor="let item of pasajeros.controls; let i = index;">
            <div class="row d-flex mb-5">
              <div class="col-xl-1 col-xxl-2"></div>
              <div class="col-xl-11 col-xxl-10 z-index--top position-relative pe-0">
                <div class="bg-grey shadow-none tours-pasajeros ps-0 pb-5 h-100 pe-2">

                  <h4 class="align-items-center d-flex bg-secondary title-bg text-white" style="float: left;">Pasajero {{i+1}}</h4>
                 <div class="label_bb">

                      <div class="col-6 d-flex align-items-center" *ngIf="form.controls['pasajeros'].controls[i].controls['bebe'].value ===1">
                        <input type="radio" class="ps-2" formControlName="bebe" [value]="1">
                        <p class="mb-0 ps-2">Pasajero bebé</p>
                      </div>
                    </div>

                  <div class="ps-5 pt-3 pe-5">
                    <div class="row">
                      <div class="col-lg-6 col-12">
                        <div class="form-control">
                          <h5 class="mb-1">Nombre completo</h5>
                          <input type="text" formControlName="nombre"
                            placeholder="Ingrese el nombre y apellido completo" class="w-100">
                          <div *ngIf="submitted && form.controls['pasajeros'].controls[i].controls['nombre'].errors" class="text-danger">
                            <div *ngIf="form.controls['pasajeros'].controls[i].controls['nombre'].errors.required">Nombre es requerido.</div>
                          </div>
                        </div>
                        <div class="form-control">
                          <h5 class="mb-1">Teléfono</h5>
                          <input type="text" formControlName="telefono" (keypress)="keypressNumber($event)"
                            placeholder="Ingrese un número de teléfono válido" class="w-100" >
                          <div *ngIf="submitted && form.controls['pasajeros'].controls[i].controls['telefono'].errors" class="text-danger">
                            <div *ngIf="form.controls['pasajeros'].controls[i].controls['telefono'].errors.required">Teléfono es requerido.</div>
                          </div>
                        </div>
                        <div class="form-control">
                          <h5 class="mb-1">Correo Electrónico</h5>
                          <input type="email" formControlName="email"
                            placeholder="Ingrese un correo electrónico válido" required class="w-100">
                          <div *ngIf="submitted && form.controls['pasajeros'].controls[i].controls['email'].errors" class="text-danger">
                            <div *ngIf="form.controls['pasajeros'].controls[i].controls['email'].errors.required">Correo electrónico es requerido.</div>
                            <div *ngIf="form.controls['pasajeros'].controls[i].controls['email'].errors.pattern">Correo electrónico no es válido.</div>
                          </div>
                        </div>
                        <div class="form-control" *ngIf="form.controls['pasajeros'].controls[i].controls['bebe'].value === 0">
                          <h5 class="mb-1">Asiento</h5>
                          <select name="asiento" formControlName="asiento" class="documento w-100" id="" (change)="onChange($event.target.value)">
                            <option value="" selected disabled>Seleccionar asiento</option>
                            <option *ngFor="let a of asientos" [value]="a.name" [disabled]="a.disabled">{{a.name}}</option>
                          </select>
                          <div *ngIf="submitted && form.controls['pasajeros'].controls[i].controls['asiento'].errors" class="text-danger">
                            <div *ngIf="form.controls['pasajeros'].controls[i].controls['asiento'].errors.required">El asiento es requerido.</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-12">
                        <div class="form-control">
                          <h5 class="mb-1">Tipo de Documento</h5>
                          <select name="tipo-documento" formControlName="tipoDocumento" class="documento w-100" id="" >
                            <option value="" selected disabled>Seleccionar tipo</option>
                            <option value="DNI">DNI</option>
                            <option value="otro">Otro</option>
                          </select>
                          <div *ngIf="submitted && form.controls['pasajeros'].controls[i].controls['tipoDocumento'].errors" class="text-danger">
                            <div *ngIf="form.controls['pasajeros'].controls[i].controls['tipoDocumento'].errors.required">Tipo de documento es requerido.</div>
                          </div>
                        </div>
                        <div class="form-control">
                          <h5 class="mb-1">N° de Documento</h5>
                          <input type="text" placeholder="Ingrese el número de documento" formControlName="numeroDocumento" (keypress)="keypressNumber($event)"
                            class="w-100" >
                          <div *ngIf="submitted && form.controls['pasajeros'].controls[i].controls['numeroDocumento'].errors" class="text-danger">
                            <div *ngIf="form.controls['pasajeros'].controls[i].controls['numeroDocumento'].errors.required">Número de documento es requerido.</div>
                          </div>
                        </div>
                        <div class="form-control">
                          <h5 class="mb-1">Observaciones</h5>
                          <textarea placeholder="Ingrese observaciones" formControlName="observaciones" class="w-100" ></textarea>
                        </div>
                        <div class="form-control">
                          <h5 class="mb-1">Tipo de habitación</h5>
                          <div class="row" style="padding-top: 10px;">
                            <div class="col-lg-3 d-flex align-items-center"  *ngFor="let hab of habitaciones">
                              <input type="radio" class="ps-2" formControlName="habitacion" [value]="hab.id"  >
                              <p class="mb-0 ps-2">{{hab.tipo}}</p>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
<section class="bg-home bg-tour-details">
  <div class="container">
      <div class="row">
          <div class="col-12 text-center z-index--top">
            <a style="cursor: pointer;"  class="btn btn-lg rounded-pill btn-primary text-white text-center align-self-center" data-bs-toggle="modal"
            (click)="submit()">Confirmar</a>
          </div>
      </div>
  </div>
</section>
